module.exports = __webpack_public_path__ + "static/media/sf-test-18.bd06bc1a.mp3";